import React from 'react';
import { useSelector } from 'react-redux';
import { selectUiState } from '../../redux/slices/ui';
import Verification from './index';
import VerificationV2 from './verification-v2';
import GuestShell from '../guest-shell';

const VerificationSwitch = props => {
  const ui = useSelector(selectUiState);

  return ui.isBookingEngine ? (
    <GuestShell
      activeTab="verification"
      bookingCode={props.match.params.booking_code}
      slug={props.match.params.slug}
    >
      <VerificationV2 {...props} />
    </GuestShell>
  ) : (
    <Verification {...props} />
  );
};

export default VerificationSwitch;
